import React from "react";

export default () => {
    return (
        <div style={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
            <svg
                width="16px"
                height="16px"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="highlight_off">
                    <path
                        id="Vector"
                        d="M9.72536 5.33398L7.9987 7.06065L6.27203 5.33398L5.33203 6.27398L7.0587 8.00065L5.33203 9.72732L6.27203 10.6673L7.9987 8.94065L9.72536 10.6673L10.6654 9.72732L8.9387 8.00065L10.6654 6.27398L9.72536 5.33398ZM7.9987 1.33398C4.31203 1.33398 1.33203 4.31398 1.33203 8.00065C1.33203 11.6873 4.31203 14.6673 7.9987 14.6673C11.6854 14.6673 14.6654 11.6873 14.6654 8.00065C14.6654 4.31398 11.6854 1.33398 7.9987 1.33398ZM7.9987 13.334C5.0587 13.334 2.66536 10.9407 2.66536 8.00065C2.66536 5.06065 5.0587 2.66732 7.9987 2.66732C10.9387 2.66732 13.332 5.06065 13.332 8.00065C13.332 10.9407 10.9387 13.334 7.9987 13.334Z"
                        fill="black"
                    />
                </g>
            </svg>
        </div>
    );
};
